import axios from 'axios';
import {
    room,
    electronConfig,
    convertPath,
    isElectron,
    strTest
} from '../libs/roomnew';
import SuccessYellow from '../components/Icons/SuccessYellow';
import TipsYellow from '../components/Icons/TipsYellow';

export default class Feedback{
    constructor(){
        this.modal = null;
        this.timeout = 0;
        this.rating = 0;

        this.kinoLogoPath = `${isElectron ?'../..': '' }/images/KinoLiveDarkBG.svg`;
        this.starIcon = `<i class="rating__icon rating__icon--star fa fa-star"></i>`;

        this.events();
    }

    events(){
        let f = this;
        let timeout;

        $('.rating__input').on('click', function(){
            f.rating = parseInt($(this).val());
            f.generalError.html('');
            f.inputsError.html('');
            f.emailError.html('');
            f.textContainer.addClass('d-flex')
            f.feedback.addClass('h-auto')
            f.feedbackDescription.addClass('d-none')
            timeout = setTimeout(() => {
                f.textContainer.addClass('expanded')
            }, 50);
            f.inputsSection.addClass('d-flex')
            if(f.rating <= 3){
                f.textArea.attr('placeholder', 'Let us know how we can improve.')
            }else{
                f.textArea.attr('placeholder', 'Let us know how we can improve. (Optional)')
            }
        })

    }

    renderModal(){
        let f = this;

        f.submitButton = $('<button/>',{
            class: 'btn kino-btn-primary send rounded-10 py-1',
            style:'width:180px;font-size:15px',
            html: 'Send Feedback'
        }).on('click', function(){
            f.sendFeedback();
        })
        f.homeButton = $('<button/>',{
            class: 'btn btn-light kino-btn-secondary',
            html: '<i class="fa fa-home" aria-hidden="true"></i> kino.live'
        }).on('click', function(){
            if(isElectron){
                location.href=api.global.dirname+'src/html/pages/welcome.ejs';
            }else{
                window.location.replace('/');
            }
        })
        f.actionButtons = $('<div/>',{
            class: 'align-items-center d-flex feedback-btn justify-content-center my-0 pb-0',
            html: [f.submitButton]
        })

        f.generalError = $('<span/>',{
            class: 'rating-error d-none',
            html: ''
        })
        f.emailInput = $('<input/>',{
            type: 'email',
            maxlength: 254,
            class: 'feedback-mail',
            placeholder: 'Email (Optional)',
            name: "feedback-mail"
        }).on('input', function(){
            f.emailError.html('')
        }).on('keyup', function(e){
            e.preventDefault();
            e.stopPropagation();
            if(e.keyCode == '13'){
                f.sendFeedback();
            }
        })
        f.inputsError = $('<span/>',{
            class: 'rating-description-error',
            html: ''
        })
        f.emailError = $('<span/>',{
            class: 'rating-description-error',
            html: ''
        })
        f.textArea = $('<textarea/>',{
            class:'w-100',
            name: "feedback",
            maxlength: 500,
            cols: "40",
            rows: "3",
            placeholder: "Let us know how we can improve."
        }).on('input', function(){
            f.inputsError.html('')
        }).on('keyup', function(e){
            e.preventDefault();
            e.stopPropagation();
            if(e.keyCode == '13'){
                f.sendFeedback();
            }
        })
        f.inputsSection = $('<div/>',{
            class: 'feedback-text ignore-drag',
            html: [f.textArea, f.inputsError, f.emailInput, f.emailError]
        })
        f.feedbackText = $('<h6/>',{
            html: ''
        })
        f.textContainer = $('<div/>',{
            class: 'form-step2',
            html: [f.feedbackText, f.inputsSection]
        })
        f.ratingGroup = $('<div/>',{
            class: 'rating-group ignore-drag my-2',
            html: ''
        })
        f.starForm = $('<div/>',{
            class: 'rating_form m-0',
            html: [f.ratingGroup, f.textContainer,f.actionButtons]
        })
        f.feedbackTitle = $('<p/>',{
            class: 'kino-color-primary ignore-drag text-16 font-weight-normal mt-3 text-center noselect',
            html: `Share your thoughts with the team`
        })
        f.feedbackDescription=$("<p/>",{
            class:'mb-0 px-2 text-center noselect text-black',
            html:`How was your Kino experience? <br> We love feedback, it’s how we get better.`
        })
        const feedbackFooter=$("<div/>",{
            class:'w-100 feedback-footer-btn',
            html:f.homeButton
        })
        f.feedback = $('<div/>',{
            class: 'feedback w-100',
            html: [f.feedbackTitle,f.feedbackDescription,f.starForm, f.generalError,feedbackFooter]
        })

        const feedbackSection=$("<div/>",{
            class:'align-items-center d-flex flex-column justify-content-center p-4 w-50 hero-background position-relative modal-feedback-section',
            html:[f.feedback]
        })


        const learnMoreTitle=$("<p/>",{
            class: 'font-weight-normal mb-0 mt-3 px-2 mb-3 text-center text-16',
            html: 'Wondering if Kino is the one?'
        })
        const learnMoreDescription=$("<p/>",{
            class: 'mb-0 px-2 text-center text-14 noselect',
            html: `Share your email below and let's dive deeper to see if Kino aligns perfectly with your needs!`
        })
        f.learnMoreEmail=$('<input/>',{
            class:'form-control mt-3 border-yellow feedback-learn-more-input',
            type:'email',
            maxlength:254,
            placeholder:"Your email"
        }).on('input',()=>{
            f.learnMoreError.html('')
        })

        f.learnMoreError=$('<span/>',{
            class:'text-danger',
            html:``
        })

        const sendEmailButton=$("<button/>",{
            class:'btn btn-yellow mt-3',
            html:'COUNT ME IN'
        }).on('click',()=>{
            this.submitLearnMoreEmail()
        })
        /**
         * <p class="font-weight-normal mb-0 mt-3 px-2 text-center text-xxl">Learn more about Kino!</p>
                        <p class="mb-0 px-2 text-center">Drop your email below to discover the full potential of Kino's Executive Workspace. Let's explore together!</p>
         */
        //section for signed in user
        const tipsTitle=$("<p/>",{
            class: 'font-weight-normal mb-0 mt-0 px-2 mb-0 text-center text-20 noselect shadow-text',
            html: `Join our AI workshop Two session event`
        })
        const eventDescription=$("<p/>",{
            class: 'font-weight-bold px-2 text-center text-17 noselect shadow-text discover-simplicity',
            style:`margin-top: 34px !important; margin-bottom: 28px !important;`,
            html: `Discover the simplicity <br><span class="yellow-text">ChatGPT</span> & Support a cause.`
        })

        const bringThemHomeNow=$("<p/>",{
            class: 'font-weight-bold mb-0 mt-3 px-2 mb-3 text-center text-16 noselect shadow-text bring-them-home-now',
            html: `BRING THEM HOME NOW!`
        })

        const bringThemHomeImage=$('<img/>',{
            style:"width:78px;border-radius: 12px;",
            src: `${isElectron ?'../..': '' }/images/event/bring-them-home.jpg`,
        })
        // const createWorkspaceItem=$('<li/>',{
        //     class:'tips-list-item',
        //     html:`<a href="#" class="tips-link">Collaborate with your team.</a>`
        // })

        // const scheduleKinoItem=$('<li/>',{
        //     class:'tips-list-item',
        //     html:`<a href="#" class="tips-link">Schedule your meetings.</a>`
        // })

        // const privateKinoItem=$('<li/>',{
        //     class:'tips-list-item',
        //     html:`<a href="#" class="tips-link">Keep everything private.</a>`
        // })

        // const TipsList=$("<ul/>",{
        //     class:'tips-list px-4',
        //     html:[
        //         createWorkspaceItem,
        //         scheduleKinoItem,
        //         privateKinoItem
        //     ]
        // })

        // const handbookDescription=$('<p/>',{
        //     class:`mt-3 mb-0 px-2 text-center text-14 noselect bring-them-home-now`,
        //     html:`There is more! Download our handbook there is everything you need to know about Kino.`
        // })
        const downloadHandbook=$("<button/>",{
            class:'btn btn-yellow mt-3 text-20 py-1',
            html:'LEARN MORE'
        }).on('click',()=>{
            if(isElectron){
                window.open(api.global.app_url+'/aiworkshop','_blank')
            }else{
                location.href='/aiworkshop';
            }
        })

        const signedInUserTips=$("<div/>",{
            class:'align-items-center d-flex flex-column justify-content-center',
            html:[`<img src="${this.kinoLogoPath}" alt="Kino" style="width:220px;height:auto;" />`]
        });
        //
        const learnMoreColumn=$("<div/>",{
            class:'align-items-center d-flex flex-column justify-content-center',
            html:[learnMoreTitle,learnMoreDescription,f.learnMoreEmail,f.learnMoreError,sendEmailButton]
        })
        f.learnMoreThankYou=$("<div/>",{
            class:`align-items-center d-flex flex-column justify-content-center`,
            html:[
                SuccessYellow,
                `<p class="font-weight-normal mb-0 mt-3 px-2 mb-3 text-center text-16 noselect">We are all set</p>`,
                `<p class="mb-0 px-2 text-center text-14 noselect">Thank you for sharing your email, we will get back to you soon.</p>`
            ]
        })
        f.learnMoreSection=$("<div/>",{
            class:`d-flex justify-content-center align-items-center w-50 colored-left-modal py-4 px-2  modal-learn-more-section`,
            html:signedInUserTips
        })
        const modalSections=$("<div/>",{
            class:'d-flex align-items-strech h-100 feedback-modal-sections',
            html:[f.learnMoreSection,feedbackSection]
        })
        const modalAbsolute=$("<div/>",{
            class:'absolute-modal-body',
            html:[modalSections]
        })
        const modalBox=$("<div/>",{
            class:'w-100 modal-feedback-box',
            style:'height:350px',
            html:[modalAbsolute]
        })

        f.modalBody = $('<div/>',{
            class: 'modal-body feedback-modal-body w-100 ignore-drag',
            html: modalBox
        })

        // f.kinoLogo = $('<img/>',{
        //     class: 'modal-kino-logo',
        //     src: f.kinoLogoPath
        // })
        f.modalHeader = $('<div/>',{
            class: 'modal-header feedback-modal-header modal-kino',
            html: ''
        })
        f.modalContent = $('<div/>',{
            class: 'modal-content feedback-modal-content border-0',
            html: [f.modalHeader, f.modalBody]
        })
        f.modalInner = $('<div/>',{
            class: 'modal-dialog modal-dialog-centered feedback-modal-dialog modal-lg',
            style: 'max-width: 800px !important;',
            role: 'document',
            html: f.modalContent
        })
        f.modal = $('<div/>',{
            class:"modal fade",
            tabindex: "-1",
            role: "dialog",
            'aria-modal': "true",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: f.modalInner
        })
        f.addStars();
        $('body').append(f.modal);
        f.modal.modal('show');
        f.events();
    }

    removeModal(){
        let f = this;
        f.timeout = setTimeout(() => {
            if(f.modal){
                f.modal.remove();
            }
            clearTimeout(f.timeout);
        }, 200);
    }

    addStars(){
        let f = this;
        for(let i=0; i<=5; i++){
            // console.log(i);
            f.ratingGroup.append(`
                ${i==0 ? '' : `<label aria-label="${i} star" class="rating__label" for="rating-${i}">${f.starIcon}</label>`}
                <input
                    ${i==0 ? 'disabled checked': ''}
                    class="rating__input ${i==0 ? 'rating__input--none' : ''}"
                    id="${i==0 ? 'rating-none': `rating-${i}`}"
                    name="rating"
                    value="${i}"
                    type="radio" />
            `)
        }
    }

    submitLearnMoreEmail(){
        const email = this.learnMoreEmail.val();
        if(email.length == 0 && !strTest.isValidEmail(email)) {
            this.learnMoreError.html(`Please enter a valid email`)
        }
        const name = this.splitName(MY_NAME)
        axios.post(convertPath('/lead/create'),{
            'first_name':name.first_name,
            'last_name':name.last_name,
            'email':email,
            'reference': "Feedback Modal"
        }).then(r=>{
            this.learnMoreSection.html(this.learnMoreThankYou)
            console.log("email submited",r.data)
        })
    }

    splitName(fullName){
        // Split the full name by space character
        const nameParts = fullName.split(" ");

        // Check if there are at least two parts (first and last name)
        if (nameParts.length >= 2) {
            // Extract first and last name
            const first_name = nameParts[0];
            const last_name = nameParts[nameParts.length - 1];
            // Return an object with the first and last name
            return {
                first_name,
                last_name
            };
        } else {
            // If there are not enough parts, return null
            return {
                first_name:'',
                last_name:nameParts.length > 0 ? nameParts[0] : 'Guest'
            };
        }
    }

    async sendFeedback() {
        let f = this;
        var text = f.textArea.val();
        var mail = f.emailInput.val();
        f.submitButton.prop({'disabled': true,})

        if((mail != '' && !strTest.isValidEmail(mail)) || f.rating == 0 || (f.rating <= '3' && text == '')){
            if(mail != '' && !strTest.isValidEmail(mail)){
                f.emailError.html('⚠ Please enter a valid email')
            }
            if(f.rating == 0){
                f.generalError.html('⚠ Rating is required')
            }
            if(f.rating <= '3' && text == ''){
                f.inputsError.html('⚠ Feedback is required');
            }
            f.submitButton.prop({'disabled': false,})
            return;
        }

        axios.post(convertPath(`/feedback/${isElectron ? 'add' : 'store'}`),{
            room_id: ROOM_NAME,
            guest_id: USER_ID,
            name: MY_NAME,
            message: text,
            stars: f.rating,
            email: mail
        }, await electronConfig()).then((request)=>{
            // console.log(request)
            // console.log(request.data)
            if(request.data.success){
                $('.rating__input').off('click')
                $('.feedback .rating-group').css('pointer-events','none')
                $('.rating__input').css('pointer-events','none')
                $('.rating__label').css('pointer-events','none')
                // f.feedbackText.html('We appreciate your feedback!')
                f.actionButtons.remove();
                f.textContainer.remove();
                f.feedbackTitle.html(`We hear you!`)
                f.feedbackDescription.html(`Thank you for taking the time to provide feedback. Your input is valuable to us.`).removeClass('d-none');
            }
        }).catch((err)=>{
            f.submitButton.prop({'disabled': false,})
        })

        // setTimeout(() => {
        //     if(isElectron){
        //         location.href=api.global.dirname+'src/html/pages/welcome.ejs';
        //     }else{
        //         window.location.replace('/');
        //     }
        // }, 3000);
    }

}
